import React from "react";
import { IconProps } from "./types";

export default function USDeIcon({ width = 40, height = 40 }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 21 20"
      fill="none"
    >
      <g clipPath="url(#clip0_59965_324299)">
        <path
          d="M10.4703 0.650391H10.4707C15.5658 0.650391 19.6962 4.82513 19.6963 9.97499V9.9754C19.6963 15.1253 15.5658 19.3002 10.4707 19.3002H10.4703C5.37519 19.3001 1.24487 15.1253 1.24487 9.9754V9.97499C1.24491 4.82515 5.37521 0.650426 10.4703 0.650391Z"
          fill="black"
          stroke="black"
          strokeWidth="1.27786"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.96334 2.16016C5.33664 2.86622 2.59718 6.09122 2.59717 9.96301C2.59717 13.8348 5.33664 17.06 8.96334 17.7661V17.0213C5.73812 16.3263 3.31905 13.4302 3.31905 9.96301C3.31907 6.49585 5.73812 3.59969 8.96334 2.90478V2.16016ZM11.9685 2.90771V2.1628C15.5885 2.87422 18.3213 6.09604 18.3213 9.96301C18.3213 13.83 15.5885 17.052 11.9685 17.7634V17.0183C15.1869 16.3182 17.5992 13.4254 17.5992 9.96301C17.5992 6.50069 15.1869 3.60778 11.9685 2.90771Z"
          fill="white"
        />
        <path
          d="M11.5793 9.69823C12.1792 9.81378 12.6444 10.0366 12.9751 10.3668C13.3058 10.6887 13.4712 11.1014 13.4712 11.6049V12.3973C13.4712 12.9998 13.2559 13.4868 12.8252 13.8582C12.3945 14.2214 11.8292 14.403 11.1294 14.403H10.8871V15.6658H10.0565V14.403H9.80274C9.3413 14.403 8.9337 14.2998 8.57992 14.0934C8.22615 13.8788 7.94929 13.5817 7.74933 13.202C7.55707 12.8141 7.46094 12.3684 7.46094 11.8649H8.29152C8.29152 12.3766 8.42995 12.7934 8.70681 13.1154C8.99137 13.429 9.36438 13.5858 9.82582 13.5858H11.1063C11.5601 13.5858 11.9254 13.4785 12.2022 13.2639C12.4791 13.0411 12.6175 12.7522 12.6175 12.3973V11.6049C12.6175 11.3242 12.5137 11.0849 12.3061 10.8868C12.1061 10.6887 11.8292 10.5608 11.4755 10.503L9.39897 10.1316C8.81449 10.0242 8.36074 9.80139 8.03774 9.46298C7.71472 9.12457 7.55322 8.6995 7.55322 8.18775V7.51918C7.55322 6.91664 7.76086 6.43791 8.17616 6.08299C8.59915 5.71984 9.15672 5.53825 9.84888 5.53825H10.0565V4.27539H10.8871V5.53825H11.1524C11.8062 5.53825 12.333 5.75285 12.7329 6.18204C13.1328 6.60299 13.3328 7.16014 13.3328 7.85348H12.5022C12.5022 7.39951 12.3791 7.03633 12.133 6.76395C11.8869 6.49157 11.5601 6.35537 11.1524 6.35537H9.84888C9.41052 6.35537 9.06059 6.46267 8.79911 6.67727C8.53761 6.88362 8.40688 7.16426 8.40688 7.51918V8.18775C8.40688 8.47664 8.50302 8.72012 8.69528 8.91822C8.89524 9.11631 9.16825 9.24838 9.51433 9.31441L11.5793 9.69823Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_59965_324299">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
